<template>
  <div>
    <b-pagination
      :total="pages.count"
      :current="pages.current"
      :rounded="rounded"
      :per-page="pages.per_page ? pages.per_page : '25'"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      @change="setPage"
    >
    </b-pagination>
  </div>
</template>
<script>
export default {
  name: 'Page',
  props: ['links', 'pages'],
  data() {
    return {
      rounded: true
    }
  },
  methods: {
    setLink(url) {
      if (url) {
        this.$emit('set-link', url)
      }
    },
    setPage(page) {
      if (page !== this.pages.current) {
        this.$emit('set-page', page)
      }
    }
  }
}
</script>
